__turbopack_context__.v({
  "athletePhoto": "LeaderboardRow-module-scss-module__IwwwXW__athletePhoto",
  "avatar": "LeaderboardRow-module-scss-module__IwwwXW__avatar",
  "avatarCompact": "LeaderboardRow-module-scss-module__IwwwXW__avatarCompact",
  "avatarImage": "LeaderboardRow-module-scss-module__IwwwXW__avatarImage",
  "avatarPlaceholder": "LeaderboardRow-module-scss-module__IwwwXW__avatarPlaceholder",
  "bronze": "LeaderboardRow-module-scss-module__IwwwXW__bronze",
  "clubFans": "LeaderboardRow-module-scss-module__IwwwXW__clubFans",
  "clubLogo": "LeaderboardRow-module-scss-module__IwwwXW__clubLogo",
  "clubMeta": "LeaderboardRow-module-scss-module__IwwwXW__clubMeta",
  "clubName": "LeaderboardRow-module-scss-module__IwwwXW__clubName",
  "clubSport": "LeaderboardRow-module-scss-module__IwwwXW__clubSport",
  "colBest": "LeaderboardRow-module-scss-module__IwwwXW__colBest",
  "colClub": "LeaderboardRow-module-scss-module__IwwwXW__colClub",
  "colFans": "LeaderboardRow-module-scss-module__IwwwXW__colFans",
  "colMain": "LeaderboardRow-module-scss-module__IwwwXW__colMain",
  "colRank": "LeaderboardRow-module-scss-module__IwwwXW__colRank",
  "colStat": "LeaderboardRow-module-scss-module__IwwwXW__colStat",
  "colTasks": "LeaderboardRow-module-scss-module__IwwwXW__colTasks",
  "colViews": "LeaderboardRow-module-scss-module__IwwwXW__colViews",
  "colWide": "LeaderboardRow-module-scss-module__IwwwXW__colWide",
  "crest": "LeaderboardRow-module-scss-module__IwwwXW__crest",
  "desktopOnly": "LeaderboardRow-module-scss-module__IwwwXW__desktopOnly",
  "details": "LeaderboardRow-module-scss-module__IwwwXW__details",
  "detailsClub": "LeaderboardRow-module-scss-module__IwwwXW__detailsClub",
  "detailsClubFans": "LeaderboardRow-module-scss-module__IwwwXW__detailsClubFans",
  "detailsClubFansLabel": "LeaderboardRow-module-scss-module__IwwwXW__detailsClubFansLabel",
  "detailsClubFansValue": "LeaderboardRow-module-scss-module__IwwwXW__detailsClubFansValue",
  "detailsStat": "LeaderboardRow-module-scss-module__IwwwXW__detailsStat",
  "detailsStatLabel": "LeaderboardRow-module-scss-module__IwwwXW__detailsStatLabel",
  "detailsStatValue": "LeaderboardRow-module-scss-module__IwwwXW__detailsStatValue",
  "detailsStats": "LeaderboardRow-module-scss-module__IwwwXW__detailsStats",
  "expandHit": "LeaderboardRow-module-scss-module__IwwwXW__expandHit",
  "flag": "LeaderboardRow-module-scss-module__IwwwXW__flag",
  "glow": "LeaderboardRow-module-scss-module__IwwwXW__glow",
  "glowInner": "LeaderboardRow-module-scss-module__IwwwXW__glowInner",
  "gold": "LeaderboardRow-module-scss-module__IwwwXW__gold",
  "headerCell": "LeaderboardRow-module-scss-module__IwwwXW__headerCell",
  "headerMain": "LeaderboardRow-module-scss-module__IwwwXW__headerMain",
  "highlight": "LeaderboardRow-module-scss-module__IwwwXW__highlight",
  "identity": "LeaderboardRow-module-scss-module__IwwwXW__identity",
  "identityClub": "LeaderboardRow-module-scss-module__IwwwXW__identityClub",
  "laurel": "LeaderboardRow-module-scss-module__IwwwXW__laurel",
  "meta": "LeaderboardRow-module-scss-module__IwwwXW__meta",
  "metaDot": "LeaderboardRow-module-scss-module__IwwwXW__metaDot",
  "mobileOnly": "LeaderboardRow-module-scss-module__IwwwXW__mobileOnly",
  "mobileViews": "LeaderboardRow-module-scss-module__IwwwXW__mobileViews",
  "mobileViewsLabel": "LeaderboardRow-module-scss-module__IwwwXW__mobileViewsLabel",
  "name": "LeaderboardRow-module-scss-module__IwwwXW__name",
  "nameClub": "LeaderboardRow-module-scss-module__IwwwXW__nameClub",
  "nameLine": "LeaderboardRow-module-scss-module__IwwwXW__nameLine",
  "nameLink": "LeaderboardRow-module-scss-module__IwwwXW__nameLink",
  "rank": "LeaderboardRow-module-scss-module__IwwwXW__rank",
  "rankBronze": "LeaderboardRow-module-scss-module__IwwwXW__rankBronze",
  "rankGold": "LeaderboardRow-module-scss-module__IwwwXW__rankGold",
  "rankSelf": "LeaderboardRow-module-scss-module__IwwwXW__rankSelf",
  "rankSilver": "LeaderboardRow-module-scss-module__IwwwXW__rankSilver",
  "requestedLogo": "LeaderboardRow-module-scss-module__IwwwXW__requestedLogo",
  "row": "LeaderboardRow-module-scss-module__IwwwXW__row",
  "rowHighlight": "LeaderboardRow-module-scss-module__IwwwXW__rowHighlight",
  "self": "LeaderboardRow-module-scss-module__IwwwXW__self",
  "silver": "LeaderboardRow-module-scss-module__IwwwXW__silver",
  "sportIcon": "LeaderboardRow-module-scss-module__IwwwXW__sportIcon",
  "srOnly": "LeaderboardRow-module-scss-module__IwwwXW__srOnly",
  "summary": "LeaderboardRow-module-scss-module__IwwwXW__summary",
  "tag": "LeaderboardRow-module-scss-module__IwwwXW__tag",
  "tagClub": "LeaderboardRow-module-scss-module__IwwwXW__tagClub",
  "value": "LeaderboardRow-module-scss-module__IwwwXW__value",
  "valueMain": "LeaderboardRow-module-scss-module__IwwwXW__valueMain",
  "valueSelf": "LeaderboardRow-module-scss-module__IwwwXW__valueSelf",
  "verifiedMark": "LeaderboardRow-module-scss-module__IwwwXW__verifiedMark",
});
